import React from "react";
import styled from "styled-components";
import {
  FaMoneyBillWave,
  FaMicrochip,
  FaUserTie,
  FaChartLine,
} from "react-icons/fa";

const Section = styled.section`
  width: 100%;
  padding: 40px 16px; /* reduced for mobile */
  // background: #f9f9f9;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (min-width: 768px) {
    padding: 64px 60px; /* reduced for desktop */
  }
`;


const SectionTitle = styled.h2`
  text-align: center;
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 40px;
  color: #1a1a1a;

  @media (min-width: 768px) {
    font-size: 42px;
    margin-bottom: 60px;
  }
`;

/* SAFE GRID: never exceeds screen width */
const GoalsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* mobile */
  gap: 16px;
  max-width: 100%;
  margin: 0 auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
`;

const GoalCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 12px;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:active {
    transform: scale(0.97);
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 14px 36px rgba(0, 0, 0, 0.12);
    }
  }

  @media (min-width: 768px) {
    padding: 28px 16px;
  }
`;

const GoalIcon = styled.div`
  width: 52px;
  height: 52px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;

  @media (min-width: 768px) {
    width: 64px;
    height: 64px;
    font-size: 30px;
    margin-bottom: 16px;
  }
`;

const GoalTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  word-break: break-word;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const OurGoals = () => {
const goals = [
  { title: "Cost Efficient", icon: <FaMoneyBillWave /> },
  { title: "Innovative Technology", icon: <FaMicrochip /> },
  { title: "Industry Expertise", icon: <FaUserTie /> },
  { title: "Scalability", icon: <FaChartLine /> },
];
  return (
    <Section id="our-goals">
      <SectionTitle>Our Goals</SectionTitle>
      <GoalsGrid>
        {goals.map((goal, index) => (
          <GoalCard key={index}>
            <GoalIcon>{goal.icon}</GoalIcon>
            <GoalTitle>{goal.title}</GoalTitle>
          </GoalCard>
        ))}
      </GoalsGrid>
    </Section>
  );
};

export default OurGoals;
